import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

function MenuList(props) {
  const menu = props.menu;
  const isFooter = props.isFooter;
  const listItems = menu
    .filter((item) => isFooter || !item.onlyFooter)
    .map((item) =>
      <li key={item.id}>
        <AppLink to={item.href} onClick={props.forwardCloseMenu}>{item.title}</AppLink>
      </li>
    );
  return (
    <ul>
      {listItems}
    </ul>
  );
}

class MenuMain extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.layout.menuMain.' + key);
  }

  render() {
    var isFooter = this.props.isFooter;

    const menu = [
      { id: 1, title: this.trans('home'), href: '/' },
      { id: 2, title: this.trans('booking'), href: 'routes.url.booking' },
      // { id: 3, title: this.trans('howItWorks'), href: 'routes.url.howItWorks' },
      { id: 4, title: this.trans('pricing'), href: 'routes.url.prices' },
      { id: 5, title: this.trans('faq'), href: 'routes.url.faq' },
      { id: 6, title: this.trans('contact'), href: 'routes.url.contact' },
      { id: 7, title: this.trans('routeHortenTorp'), href: 'routes.url.hortenTorp', onlyFooter: true },
      { id: 8, title: this.trans('complaint'), href: 'routes.url.complaint', onlyFooter: true },
    ];

    return (
      <Fragment>
        <MenuList
          menu={menu}
          forwardCloseMenu={this.props.forwardCloseMenu}
          isFooter={isFooter}
        />
      </Fragment>
    )
  }
}

export default MenuMain;
